  
import * as React from 'react'
import ToSection from './ToSection'

import FromSelect from './FromSelect'
import SubjectSection from './SubjectSection'
import { BodyEditor } from '@/components/WritingMessageModal/MessageModalContent/BodyEditor'

import DraftManagerService from '@/app-domains/messages/draft/service/DraftManager.service'
import sessionService from '@/app-domains/user/session/session.service'

import './styles.sass'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import HeaderSection from './HeaderSection/HeaderSection'
import commonsService from '@/services/commons.service'
import MobileHeaderSection from './HeaderSection/MobileHeaderSection'

export default function MessageModalContent (props) {
  const defaultDomain = sessionService.getMe().me.defaultdomain
  // eslint-disable-next-line
  const [canDelete, setCanDelete] = React.useState(!!props.draft?.id || false)

  useRenderEvent(['DRAFT_MESSAGE:UPDATE', 'DRAFT_MESSAGE:SWITCHED'], () => {
    const currentDraft = DraftManagerService.getCurrentDraftMessageFromStore()
    if (!currentDraft?.id) return
    setCanDelete(true)
  })

  // eslint-disable-next-line
  async function discardDraft () {
    setCanDelete(false)
    props.setShouldEditOnModal(false)
    await props.discardDraft()
  }

  return (
    <div className='message-modal'>
      <div className='message-modal-anchor'>
        {commonsService.isMobile() ? <MobileHeaderSection draft={props.draft} onClose={props.onClose} defaultDomain={defaultDomain}/> : <HeaderSection onClose={props.onClose}/> }
        <div className='message-modal-main'>
          { commonsService.isMobile()
            ? <></>
            : <div className='from-box-section'>
              <FromSelect draft={props.draft} defaultDomain={defaultDomain}/>
            </div> }
          <ToSection draft={props.draft} thread={props.thread}/>
          <div className='message-modal-divider'/>
          <SubjectSection subject={props.draft?.subject}/>
          <div className='message-modal-divider'/>
          <BodyEditor draft={props.draft} parentMessageId={props.parentMessageId}/>
        </div>
      </div>
    </div>
  )
}
